var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 90,
    viewBox: "0 0 86 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.6208 0V89.6811H0L12.4268 44.8405L0 0H85.6208Z",
    fill: "url(#paint0_linear_126_176)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0002 31.6007C33.6374 38.1839 35.0259 49.109 42.3144 53.9487C42.5545 54.1083 42.874 54.0766 43.0803 53.8751C44.6147 52.3758 45.9128 50.9236 47.0494 49.0766C47.2233 48.7941 47.1151 48.4274 46.8234 48.2693C45.7117 47.6671 44.6054 46.5377 43.9827 45.3448L43.982 45.3452C43.236 43.8597 42.982 42.1946 43.3769 40.4749C43.3773 40.475 43.3778 40.4751 43.3782 40.4751C43.8326 38.2734 46.1963 36.2253 48.0016 34.3312C47.9978 34.3299 47.9941 34.3286 47.9903 34.3273L54.7542 27.4238C57.4497 24.6727 61.8835 24.65 64.6069 27.3735C67.358 30.0689 67.4034 34.525 64.708 37.2761L60.6111 41.4891C60.4214 41.6841 60.3599 41.9686 60.4487 42.2257C61.392 44.9612 61.624 48.8183 60.9919 51.7325C60.9741 51.814 61.0748 51.8674 61.1332 51.8078L69.8528 42.9082C75.4231 37.223 75.3758 27.9667 69.7478 22.3387C64.0042 16.5951 54.6539 16.6429 48.9694 22.4447L40.0351 31.5633C40.0233 31.5758 40.0121 31.5884 40.0002 31.6007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3015 55.2024C56.3013 55.2027 56.3011 55.203 56.301 55.2034C56.3066 55.201 56.3118 55.1988 56.3174 55.1964C58.0969 51.9424 58.4472 48.2104 57.6132 44.5723L57.6094 44.5762L57.6053 44.5744C56.8134 41.3341 54.6405 38.1165 51.6895 36.1355C51.4356 35.9651 51.0301 35.9848 50.7924 36.177C49.2975 37.3857 47.8343 38.9356 46.8689 40.9135C46.7172 41.2241 46.8308 41.5971 47.1296 41.7705C48.2501 42.4211 49.262 43.3734 49.9395 44.6378L49.9405 44.6371C50.4685 45.5303 50.9888 47.2251 50.6518 49.0461C50.6516 49.0461 50.6513 49.0461 50.6511 49.0461C50.3366 51.4604 47.8986 53.675 45.9605 55.6705L45.9614 55.6714C44.4861 57.1801 40.7357 61.0034 39.234 62.5376C36.5386 65.2886 32.0825 65.3341 29.3315 62.6386C26.5805 59.9432 26.535 55.4871 29.2304 52.7361L33.3395 48.5104C33.5257 48.3189 33.589 48.0405 33.5062 47.7865C32.5938 44.9871 32.3438 41.2169 32.9198 38.306C32.9358 38.2249 32.836 38.1731 32.778 38.2322L24.1896 46.9979C18.5622 52.7415 18.6099 62.0927 24.2957 67.7784C30.039 73.4056 39.342 73.3105 44.9691 67.5673C46.924 65.3806 55.2923 57.6327 56.3015 55.2024Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_126_176",
    x1: 68.241,
    y1: 0,
    x2: 68.241,
    y2: 89.6811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C32A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A5298"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "translate(20 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.48ae5555e07025ce0dfc04a58f47ac03.svg";
export { ForwardRef as ReactComponent };